module.exports = __webpack_public_path__ + "img/bind2.09173056.jpg";